import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";
import { AxiosResponse } from "axios";
import {httpBackofficeAxiosApi} from "@/shared/axios.backoffice.helper";
import {useRequest} from "vue-request"
import moment from "moment-timezone";

export type UserCategoryBackofficeMeta = {
  visible: boolean;
  name_en: string;
  usertype: string;
  group: string;
  other: boolean;
}

export enum UserCategoryGroup {
  business = 'business',
  business_service = 'business_service',
  individual = 'individual',
  business_affiliate_network = 'business_affiliate_network',
  business_advertising_network = 'business_advertising_network',
  business_webmaster_service = 'business_webmaster_service',
  business_marketing_agency = 'business_marketing_agency',
}


export type UserCategoryBackoffice = {
  id: string;
  name: string;
  meta: UserCategoryBackofficeMeta
}

export const getUsertypeName = (usertype: string) => {
  return userUsertypes.find((item) => item.value === usertype)?.label ?? usertype
}

export const userUsertypes = [
  {label: 'Бизнес', value: 'LEGAL'},
  {label: 'Индивидуальный', value: 'INDIVIDUAL'},
]

export const userCategoryGroups = [
  {label: 'Бизнес', value: UserCategoryGroup.business},
  {label: 'Бизнес (Сервисы)', value: UserCategoryGroup.business_service},
  {label: 'Индивидуальный', value: UserCategoryGroup.individual},
  {label: 'Бизнес (Партнерские программы)', value: UserCategoryGroup.business_affiliate_network},
  {label: 'Бизнес (Рекламные сети)', value: UserCategoryGroup.business_advertising_network},
  {label: 'Бизнес (Сервисы для вебмастеров)', value: UserCategoryGroup.business_webmaster_service},
  {label: 'Бизнес (Маркетинговые агентства)', value: UserCategoryGroup.business_marketing_agency}
]


export const getUserCategoryGroupName = (group: string) => {
  if (!group || group == 'null') {
    return '';
  }
  return userCategoryGroups.find((item) => item.value === group)?.label ?? group
}

export interface UserCategoryStatItemInterface {
  count: number;
  categoryId: string;
  userType: string;
}

export const userCategoryNullOption = {
  id: 'null',
  name: 'Без категории',
  group: null,
  meta: {
    group: 'other',
    name_en: 'Without category'
  },
  filterNamefield: 'Без категории'
}


export const getUserCategoriesStat = (periodBegin = null, periodEnd = null) => {
  return httpAxiosApi.post('/backofficeapi/settings/usercategories/stat', {
    m: periodBegin || periodEnd ? {
      periodBegin: periodBegin ? periodBegin : null,
      periodEnd: periodEnd ? periodEnd : null
    } : {}
  }).then((response: AxiosResponse<{categoriesStat: UserCategoryStatItemInterface[]}>) => {
    return response.data?.categoriesStat as UserCategoryStatItemInterface[];
  })
}

export const useBackofficeUserCategoriesStatMod = (enabled = true, options = {}) => {
  return useRequest(() => {
    // const dt = moment();
    // const periodBegin = dt.clone().subtract(3, 'years');
    return getUserCategoriesStat()
  }, {
    cacheKey: () => {
      return '/backofficeapi/settings/usercategories/stat'
    },
    manual: !enabled,
    ...options,
  })
}

export const fetchBackofficeUserCategories = () => {
  return httpBackofficeAxiosApi.get('/backofficeapi/settings/usercategories/list')
    .then((response) => {
      return [...response.data.categories];
    })
}

export const useBackofficeUserCategories = () => {
  return useRequest(fetchBackofficeUserCategories, {
    cacheKey: '/backofficeapi/settings/usercategories/list'
  })
}
